<template>
  <div
    class="wrapper wrapper-content animated fadeInRight"
    style="padding: 5px 20px 10px"
  >
    <div class="row" style="height: 77vh">
      <jpc-calendar
        :searchParam="searchParams"
        :eventList="eventList"
        @changeEventType="handleChangeEventType"
        @changeFilter="handleChangeFilter"
        @export="handleExport"
        @changeMonth="handleGetEventList"
        @clickEvent="handleClickEvent"
      ></jpc-calendar>
    </div>
  </div>
</template>
<script>
import JpcCalendar from "../components/jpc-calendar/jpc-calendar";
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  components: {
    JpcCalendar,
  },
  data() {
    return {
      searchParams: {
        pageSize: 999999,
        archivedStatus:0,
        pageIndex: 1,
        sortName: "",
        sortType: "",
        searchName: "",
        districtCode:"",
        sourceType: ["Confirmed Event"], //请求时换成逗号相隔的字符串
        ideaCategory: [], //请求时换成逗号相隔的字符串
        schoolCode: [], //请求时换成schoolCode组成的数组
      },
      eventList: [],
    };
  },
  computed: {
    sourceTypeMap() {
      return {
        "Promotion Event": 1,
        "Confirmed Event": 2,
      };
    },
    baseURL() {
      return config.domain + "/";
    },
    userRole() {
      const res = JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType;
    },
  },
  created() {},
  mounted() {
    if(this.userRole==0) this.searchParams.districtCode = JSON.parse(sessionStorage.getItem("userInfo")).userDistrictCode
    const currentDate = this.$dayjs();
    this.getEventList(currentDate);
  },
  methods: {
    handleChangeFilter(e) {
      this.searchParams.ideaCategory = e.ideaCategory;
      this.searchParams.schoolCode = e.schoolCode;
      this.searchParams.districtCode = e.districtCode;
    },
    handleGetEventList(e) {
      this.getEventList(e.currentDate);
    },
    async getEventList(currentDate) {
      if (!this.searchParams.sourceType.length) return (this.eventList = []);
      let userInfo = this.getAuthObj();
      let sourceType = "";
      this.searchParams.sourceType.forEach((i, index) => {
        if (index == this.searchParams.sourceType.length - 1)
          sourceType += this.sourceTypeMap[i];
        else sourceType += `${this.sourceTypeMap[i]},`;
      });
      let ideaCategory = "";
      const categoryList = this.searchParams.ideaCategory.map((i) => {
        return i.substr(0, 1);
      });
      const schoolCode = this.searchParams.schoolCode.map((i) => {
        return i.schoolCode;
      });
      categoryList.forEach((i, index) => {
        if (index == categoryList.length - 1) ideaCategory += i;
        else ideaCategory += `${i},`;
      });
      const param = {
        ...this.searchParams,
        sourceType,
        ideaCategory,
        schoolCode,
        yearMonth: currentDate.format("YYYY-MM"),
        ...userInfo,
        apiUrl: "/schoolEventRequest/getSchoolEventRequests",
      };
      let data = await this.$store.dispatch("apiEvent", param);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.eventList = data.data.result.schoolRequest;
    },
    handleChangeEventType(e) {
      this.searchParams.sourceType = e;
    },
    async handleExport(e) {
      let userInfo = this.getAuthObj();
      const params = {
        ...userInfo,
        ...e,
      };
      const formDateParams = new FormData()
      const keyList = Object.keys(params)
      keyList.forEach(i=>{
        formDateParams.append(i,params[i])
      })
      const { data } = await axios.post(
        this.baseURL + "schoolEventRequest/export",
        formDateParams,
        {
          responseType: "blob",
        }
      );
      if (data.status_code) {
        if (data.status_code == "000104") return this.timeoutEvent();
        this.$store.getters.warning.warningMsg = data.status_message;
        this.$store.getters.warning.warningFalg = true;
      } else {
        const file = new Blob([data]);
        const xlsFileName =
          "jpc_calendar_" +
          this.$dayjs().format("YYYY_YYYYMMDDHHmmss") +
          ".xls";
        const url = window.URL.createObjectURL(new Blob([file]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", xlsFileName);
        document.body.appendChild(link);
        link.click();
      }
    },
    handleClickEvent(e) {
      if (e.sourceType == 1) {
        this.$router.push({
          path: "/main/promotionEventDetail",
          query: {
            id: e.eventId,
          },
        });
      } else {
        this.$router.push({
          path: "/main/confirmedEventDetail",
          query: {
            id: e.id,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>